import { useEffect, useState } from "react";
import { toast } from "sonner";
import { listUsers, createUser, changeUserRole, setUserActive, apiErr } from "@/lib/api";

const ROLES = [{ v: "owner_admin", l: "Owner/Admin" }, { v: "coordinator_admin", l: "Coordinator/Admin" }];

export default function UsersAccess() {
  const [users, setUsers] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [f, setF] = useState({ name: "", email: "", role: "coordinator_admin" });
  const [busy, setBusy] = useState(false);
  const load = () => listUsers().then(setUsers).catch(() => setUsers([]));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.name.trim() || !f.email.trim()) return toast.error("Name and email are required.");
    setBusy(true);
    try { await createUser({ name: f.name.trim(), email: f.email.trim(), role: f.role });
      toast.success("User invited — a secure set-password link was emailed.");
      setShowAdd(false); setF({ name: "", email: "", role: "coordinator_admin" }); load();
    } catch (e) { toast.error(apiErr(e?.response?.data?.detail)); } finally { setBusy(false); }
  };
  const setRole = async (u, role) => { try { await changeUserRole(u.id, role); toast.success("Role updated."); load(); } catch (e) { toast.error(apiErr(e?.response?.data?.detail)); } };
  const toggle = async (u) => { try { await setUserActive(u.id, !u.active); toast.success(u.active ? "User deactivated." : "User reactivated."); load(); } catch (e) { toast.error(apiErr(e?.response?.data?.detail)); } };

  return (
    <div data-testid="users-access">
      <div className="record-head" style={{ marginBottom: 8 }}>
        <div>
          <h1 className="record-title">Users &amp; Access</h1>
          <div className="mut record-sub">Owner/Admin only — manage internal MIHP staff access.</div>
        </div>
        <button className="btn primary" onClick={() => setShowAdd(true)} data-testid="add-user-btn">Invite user</button>
      </div>

      {users === null ? <div className="empty">Loading…</div> : (
        <div className="oa-list">
          {users.map((u) => (
            <div key={u.id} className="oa-card" data-testid={`user-${u.id}`}>
              <div className="oa-row">
                <div className="oa-main">
                  <div className="oa-title">{u.name} <span className={`oa-badge ${u.active ? "on" : "off"}`} data-testid={`user-active-${u.id}`}>{u.active ? "Active" : "Inactive"}</span></div>
                  <div className="mut oa-meta">{u.email}</div>
                </div>
                <div className="oa-actions">
                  <select className="ca-input" value={u.role} onChange={(e) => setRole(u, e.target.value)} data-testid={`user-role-${u.id}`} style={{ maxWidth: 190 }}>
                    {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
                  </select>
                  <button className="btn sm ghost" onClick={() => toggle(u)} data-testid={`user-toggle-${u.id}`}>{u.active ? "Deactivate" : "Reactivate"}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showAdd && (
        <div className="modal-scrim" onClick={() => setShowAdd(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} data-testid="add-user-modal" style={{ maxWidth: 480 }}>
            <div className="modal-head" style={{ display: "flex", alignItems: "center" }}><h2 style={{ flex: 1 }}>Invite internal user</h2><button className="btn sm ghost" onClick={() => setShowAdd(false)} data-testid="add-user-close" aria-label="Close">✕</button></div>
            <div className="modal-body">
              <label className="oa-lbl">Full name<input className="ca-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="user-name" /></label>
              <label className="oa-lbl" style={{ marginTop: 10 }}>Email<input className="ca-input" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="user-email" /></label>
              <label className="oa-lbl" style={{ marginTop: 10 }}>Role
                <select className="ca-input" value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="user-role-select">
                  {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
                </select>
              </label>
              <p className="mut" style={{ fontSize: ".78rem", marginTop: 8 }}>The user receives a secure link to set their own password. No password is emailed or shown.</p>
              <button className="mh-save" disabled={busy} onClick={add} data-testid="user-submit" style={{ marginTop: 12 }}>{busy ? "Inviting…" : "Send invite"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
